const currentYear = new Date().getFullYear();

export const options = {
  isMobile: () => {
    return /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  isOnAppleDevice: () => {
    return /(iPhone|iPod|iPad)/i.test(navigator.userAgent);
  },
  bigScreenSize: 1800,
  priceRanges: {
    monthly: {
      min: 100,
      max: 800
    },
    carPrice: {
      min: 15000,
      max: 35000
    }
  },
  initialPrices: {
    monthly: {
      min: 100,
      max: 800
    },
    carPrice: {
      min: minPrice => Math.round(minPrice / 5) * 1.5,
      max: maxPrice => Math.round(maxPrice / 5)
    }
  },
  paymentType: "monthly",
  year: {
    from: currentYear - 6,
    to: currentYear
  },
  getCarsPerPage: () =>
    options.isMobile() ? 4 : window.innerWidth > options.bigScreenSize ? 8 : 6
};
